/**
 * Canonical mass and length conversion factors.
 * Keep definitions aligned with Hourrier-API `src/shared/dictionaries/unitConversion.dictionary.ts`.
 *
 * Mass: international avoirdupois (1 lb = 453.592 g; 1 lb = 16 oz).
 * Length: SI definition of inch (1 in = 25.4 mm exactly).
 */

// --- Mass (avoirdupois) ---

export const GRAMS_PER_POUND = 453.592

export const GRAMS_PER_KILOGRAM = 1000

/** Avoirdupois ounces per pound */
export const OUNCES_PER_POUND = 16

/** Grams per avoirdupois ounce (derived from lb so lb/oz definitions stay consistent) */
export const GRAMS_PER_OUNCE = GRAMS_PER_POUND / OUNCES_PER_POUND

export const POUNDS_PER_GRAM = 1 / GRAMS_PER_POUND

export const POUNDS_PER_KILOGRAM = GRAMS_PER_KILOGRAM / GRAMS_PER_POUND

export const KILOGRAMS_PER_POUND = GRAMS_PER_POUND / GRAMS_PER_KILOGRAM

/** Multiply ounces by this to get pounds */
export const POUNDS_PER_OUNCE = 1 / OUNCES_PER_POUND

// --- Length ---

/** Millimeters per inch (exact by SI definition) */
export const MILLIMETERS_PER_INCH = 25.4

export const MILLIMETERS_PER_CENTIMETER = 10

/** Centimeters per inch */
export const CENTIMETERS_PER_INCH = MILLIMETERS_PER_INCH / MILLIMETERS_PER_CENTIMETER

export const INCHES_PER_MILLIMETER = 1 / MILLIMETERS_PER_INCH

export const CENTIMETERS_PER_MILLIMETER = 1 / MILLIMETERS_PER_CENTIMETER
